import React, {ReactElement} from 'react';
import {Button} from '@customink/pigment-react';
import {useDomPurify} from '../../hooks';

type Props = {
  sizeChartHTML: string;
  isHidden: boolean;
  handleToggleSizeChart: React.MouseEventHandler;
};

const SizeChart: React.FC<Props> = ({
  sizeChartHTML,
  isHidden,
  handleToggleSizeChart
}: Props): ReactElement => {
  const {sanitizer} = useDomPurify();

  return (
    <div>
      <Button
        className="stores-productDetails-sizeChart--toggle"
        onClick={handleToggleSizeChart}
        variant="link">
        View Sizing Guide
      </Button>
      {!isHidden && (
        <div
          className="stores-productDetails-sizeChart--chart"
          dangerouslySetInnerHTML={{__html: sanitizer(sizeChartHTML)}}
        />
      )}
    </div>
  );
};

export default SizeChart;
